import talendFlowService from '@/service/talent-flow';
import welfareService from '@/service/welfare';
import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import { observable, action, runInAction } from 'mobx';
import moIndex from '../../store';

const moPortrait = observable({
  portraitActive: '',
  categoryList: [],
  talentPortraitList: <any>{},
  hotProfessionaList: [],
});

// 获取人才画像职能数据

const getCategoryList = action(async () => {
  const params = {
    industry: moIndex.industry.code,
  };
  const res = await talendFlowService.categoryList(params)
  const list = res?.map((item: any) => {
    const items: any = { code: item.code, value: item.name };
    return items;
  });
  runInAction(() => {
    moPortrait.categoryList = list;
    moPortrait.portraitActive = !isEmpty(list) ? list[0].code : '';
  });
});

// 获取人才画像数据
const getTalentPortrait = action(async () => {
  const param = {
    industry: moIndex.industry.code,
    category: moPortrait.portraitActive,
  };
  const res = await talendFlowService.TalentPortrait(param)
  runInAction(() => {
    moPortrait.talentPortraitList = res;
  });
});

// 获取热门专业数据
const getHotProfessional = action(async () => {
  const param = {
    industry: moIndex.industry.code,
    category: moPortrait.portraitActive,
  };
  const res = await talendFlowService.HotProfessional(param);
  runInAction(() => {
    moPortrait.hotProfessionaList = res;
  });
});

// 切换各城市招聘需求量及变化tab

const changePortraitActive = action((val: string) => {
  getTalentPortrait();
  getHotProfessional();
  runInAction(() => {
    moPortrait.portraitActive = val;
  });
});


// 页面初始化

const talentFlowInit = action(async () => {
  await getCategoryList();
  await Promise.all([
    getTalentPortrait(),
    getHotProfessional(),
  ]);
});

export default moPortrait;
export { changePortraitActive, talentFlowInit };
